module.exports = __webpack_public_path__ + "img/2.e716e338.png";